import * as React from 'react';
import PropTypes from 'prop-types';
import ol_source_OSM from 'ol/source/OSM';
import ol_layer_Tile from 'ol/layer/Tile';
import {Util} from '../util';
import Map from '../map';

export class Tile extends React.Component<any, any> {

  layer: ol_layer_Tile;

  options: any = {
    zIndex: undefined,
    opacity: undefined,
    preload: undefined,
    source: undefined,
    visible: undefined,
    extent: undefined,
    minResolution: undefined,
    maxResolution: undefined,
    useInterimTilesOnError: undefined
  };

  events: any = {
    'change': undefined,
    'change:extent': undefined,
    'change:maxResolution': undefined,
    'change:minResolution': undefined,
    'change:opacity': undefined,
    'change:preload': undefined,
    'change:source': undefined,
    'change:useInterimTilesOnError': undefined,
    'change:visible': undefined,
    'change:zIndex': undefined,
    'postcompose': undefined,
    'precompose': undefined,
    'propertychange': undefined,
    'render': undefined
  };

  constructor(props) {
    super(props);
    console.log('Tile constructor');
  }

  render() {
    return null;
    console.log('Tile render() .....');
  }

  componentDidMount () {
    console.log('Tile componentDidMount() .....');
    let options = Util.getOptions(Object.assign(this.options, this.props));
    options.source = options.source || new ol_source_OSM();
    this.layer = new ol_layer_Tile(options);
    if(this.props.zIndex){
      this.layer.setZIndex(this.props.zIndex);
    }
    this.context.mapComp.layers.push(this.layer);
    if(this.context.mapComp.map)
      this.context.mapComp.map.addLayer(this.layer); //hoan add dongnay
    let olEvents = Util.getEvents(this.events, this.props);
    for(let eventName in olEvents) {
      this.layer.on(eventName, olEvents[eventName]);
    }
  }

  componentWillReceiveProps (nextProps) {
    if(nextProps != this.props && false){ //hoand add false vao de tranh flick man hinh
      console.log('Tile componentWillReceiveProps() .....');      
      let options = Util.getOptions(Object.assign(this.options, this.props));
      this.context.mapComp.map.removeLayer(this.layer);
      this.layer = new ol_layer_Tile(options);
      if(this.props.zIndex){
        this.layer.setZIndex(this.props.zIndex);
      }
      this.context.mapComp.map.addLayer(this.layer);

      let olEvents = Util.getEvents(this.events, this.props);
      for(let eventName in olEvents) {
        this.layer.on(eventName, olEvents[eventName]);
      }
    }
  }
  
  componentWillUnmount () {
    console.log('tile unmount');  
    this.context.mapComp.map.removeLayer(this.layer);
  }

}

Tile.contextTypes = {
  mapComp: PropTypes.instanceOf(Map)
};
